module.exports = __webpack_public_path__ + "media/case_studies/hero-aabed509.jpg";